<template>
    <form>
        <ConsultCancelDialog ref="consultCancelDialog" @canceled="onCancel"/>

        <fieldset style="margin-bottom: 20px;">
            <legend>
                <a :href="'https://doctu.ru/consult/question/' + question.title_slug"
                   target="_blank"
                   v-tooltip="'https://doctu.ru<br/>/consult/question<br/>/' + question.title_slug"
                   class="comma"
                >
                    <span v-if="question.user_name">{{ question.user_name }}</span>
                    <span v-if="question.user_email">{{ question.user_email }}</span>
                </a>
            </legend>

            <table class="grid">
                <tr>
                    <td colspan="2">
                        <span class="comma">
                            <span v-if="question.user_sex === 'MALE'">Мужчина</span>
                            <span v-if="question.user_sex === 'FEMALE'">Женщина</span>
                            <span v-if="question.user_age">{{ question.user_age | pluralize('', '$ год', '$ года', '$ лет') }}</span>
                            <span v-if="question.is_anonym">анонимно</span>
                        </span>
                    </td>
                    <td align="center" style="font-size: 16px;">
                        <b v-if="question.type === 'INDIVIDUAL'">Индивидуальный</b>
                    </td>
                    <td align="right" style="font-size: 16px;">
                        <b v-if="question.type === 'FREE'">бесплатно</b>
                        <b v-else>{{ question.price }} руб.</b>
                    </td>
                </tr>
                <tr>
                    <td width="33%" colspan="2">
                        <select v-model="question.doctor_speciality_id" style="max-width: 500px;">
                            <option v-for="speciality in specialities" :value="speciality.value">
                                {{ speciality.text }}
                            </option>
                        </select>
                    </td>
                    <td align="center" style="font-size: 16px;">
                        <b  v-if="question.type === 'INDIVIDUAL'">{{question.individualConsultant.fullName}}</b>
                    </td>
                    <td align="right">
                        <b>{{ question.created_at | formatDateTime }}</b>,
                        источник:
                        <span v-if="question.source === 'SITE'" tooltip="Сайт"><i class="fa fa-desktop"></i></span>
                        <span v-if="question.source === 'MOBILE'" tooltip="Mobile"><i class="far fa-mobile"></i></span>
                        <span v-if="question.source === 'ANDROID'" tooltip="Android"><i class="fab fa-android"></i></span>
                        <span v-if="question.source === 'IOS'" tooltip="iOs"><i class="fab fa-apple"></i></span>
                        <b>{{ question.source }}</b>
                    </td>
                </tr>
                <tr>
                    <td colspan="4">
                        <div class="inputLargeMarkable">
                            <div v-text="question.title"></div>
                            <input v-model="question.title"
                                   class="large question-title"
                                   v-beautify.literal="'capitalize itemclean striptags trim typograf'">
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="4">
                        <div class="textareaMarkable">
                            <div v-text="question.text"/>
                            <textarea v-model="question.text"
                                      class="question-text"
                                      v-beautify.literal="'capitalize itemclean striptags trim typograf'"/>
                        </div>
                        <div class="comma">
                          <template v-for="filename in question.files" >
                            <a v-if="filename==='deletedFile'" href="#" @click.prevent>
                              <i class="fa fa-file-xmark"/>&nbsp;Файл удален
                            </a>
                            <a v-else :href="prepareFileUrl(filename)" target="_blank">
                              <i class="fa fa-user" v-if="filename.includes('/photo/')"></i>
                              <i class="fa fa-file" v-else></i>&nbsp;
                              {{filename.replace(/^.*[\\\/]/, '')}}
                            </a>
                          </template>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td width="67%" colspan="3">
                        <strong v-if="question.moderated && !question.published">
                            {{ question.unpublish_reason }}
                        </strong>
                    </td>
                    <td width="33%">
                        <div class="controls" style="float: right; white-space: nowrap;">
                            <template v-if="
                                (question.type !== 'FREE'  && $can('admin.consult.questionsList.questionsPayable.update')) ||
                                (question.type === 'FREE' && $can('admin.consult.questionsList.questionsFree.update'))">
                                <template v-if="!question.moderated">
                                    <v-loading-component @click="publish">
                                        <template slot-scope="{ loadingClass }">
                                            <button :class="['greenHover', loadingClass]">Опубликовать</button>
                                        </template>
                                    </v-loading-component>
                                    <button class="redHover" @click.prevent.stop="unpublish">Отклонить</button>
                                </template>
                                <template v-if="question.moderated && question.published">
                                    <v-loading-component @click="save">
                                        <template slot-scope="{ loadingClass }">
                                            <button :class="['blueHover', loadingClass]">Сохранить</button>
                                        </template>
                                    </v-loading-component>
                                    <button class="redHover" @click.prevent.stop="unpublish">Отклонить</button>
                                </template>
                                <template v-if="question.moderated && !question.published">
                                    <v-loading-component @click="save">
                                        <template slot-scope="{ loadingClass }">
                                            <button :class="['blueHover', loadingClass]">Сохранить</button>
                                        </template>
                                    </v-loading-component>
                                    <v-loading-component @click="publish" v-if="question.type === 'FREE'">
                                        <template slot-scope="{ loadingClass }">
                                            <button :class="['greenHover', loadingClass]">Опубликовать</button>
                                        </template>
                                    </v-loading-component>
                                </template>
                            </template>
                            <template v-if="question.type === 'FREE' && $can('admin.consult.questionsList.questionsFree.delete')">
                                <v-loading-component @click="deleteQuestion">
                                    <template slot-scope="{ loadingClass }">
                                        <button :class="['redHover', loadingClass]">Удалить</button>
                                    </template>
                                </v-loading-component>
                            </template>
                        </div>
                    </td>
                </tr>
            </table>
        </fieldset>
    </form>
</template>

<script>
import ConsultCancelDialog from "@dialogs/admin/consult/ConsultCancel";

export default {
    components: {
        ConsultCancelDialog
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        specialities: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            question: this.item,
        }
    },
    methods: {
        makeRequest(requestType, data, btn = null) {
            btn?.startLoadingAnimation();

            this.axios.post('questionsList/' + requestType + '/' + data.id, data)
                .then((response) => {
                    this.$emit('updated');
                    this.$bus.fire('updateMenu');

                    btn?.stopLoadingAnimation()
                })
                .catch(() => btn?.stopLoadingAnimation());
        },

        onCancel(unpublishReason) {
            let data = this.question;
            data.unpublish_reason = unpublishReason;

            this.makeRequest('reject', data)
        },

        save(btn) {
            this.makeRequest('update', this.question, btn);
        },

        publish(btn) {
            this.makeRequest('publish', this.question, btn);
        },

        unpublish() {
            this.$refs.consultCancelDialog.show();
        },

        deleteQuestion (btn) {
            this.$modal('Удалить?', {
                    name: 'Да',
                    btnClass: 'red',
                    callback: () => {
                        this.makeRequest('delete', this.question, btn);
                    }
                },
                {
                    name: 'Отмена'
                }
            );
        },

        prepareFileUrl(fileUrl) {
            return fileUrl.indexOf('http') === -1 ? '//' + fileUrl : fileUrl;
        },
    },
    watch: {
        item: {
            handler(newVal) {
                this.question = newVal;
            },
            deep: true
        }
    },
}
</script>
